import firebase from "firebase";
import {deserialize, serialize} from "serializr";
import {LocalizationModel} from "@/modules/mlocalization/models/LocalizationModel";
import {LocalizationStoreUtils} from "@/modules/mlocalization/database/LocalizationStoreUtils";
import {uuid} from "vue-uuid";
import {TimeUtils} from "@/common/TimeUtils";

export default {
    namespaced: true,
    state: {
        mLocalizations: new LocalizationModel(),
    },
    getters: {
        getLocalizations: state => {
            return state.mLocalizations;
        },
    },
    mutations: {
        setLocalizations(state, values) {
            state.mLocalizations = values;
        },
    },
    actions: {
        init({/*commit*/}) {
            console.info('localization-store initialized.');
            return LocalizationStoreUtils.fethLocalizations()
        },
        addKey({/*commit*/}, data){
            var finalData = data
            finalData.owner = firebase.auth().currentUser.uid
            let db = firebase.database();
            return db.ref("/localizations/keys/" + data.key_id)
            .set(finalData).then(() => {
                return LocalizationStoreUtils.fethLocalizations()
            }, (reason) => {
                console.error("addGroup failed: " + reason);
            });
        },
        updateKeys({/*commit*/}, data){
            let db = firebase.database();
            return db.ref("/localizations/")
                .update(data).then(() => {
                    return LocalizationStoreUtils.fethLocalizations()
                }, (reason) => {
                    console.error("updateKeys failed: " + reason);
                });
        },
        addKeys({/*commit*/}, data){
            var finalData = {}
            for (let d in data){
                var a = data[d]
                a.owner = firebase.auth().currentUser.uid
                finalData[data[d].key_id] = a
            }
            let db = firebase.database();
            return db.ref("/localizations/keys/")
            .update(finalData).then(() => {
                return LocalizationStoreUtils.fethLocalizations()
            }, (reason) => {
                console.error("addGroup failed: " + reason);
            });
        },
        editKeyValue({/*commit*/}, data){
            let db = firebase.database();
            let newData = {}
            newData['owner'] = firebase.auth().currentUser.uid
            newData[data.language.name] = data.value
            newData["group_id"] = data.group_id
            return db.ref("/localizations/keys/" + data.key_id)
            .update(newData).then(() => {
                return LocalizationStoreUtils.fethLocalizations()
            }, (reason) => {
                console.error("addGroup failed: " + reason);
            });
        },
        deleteKey({/*commit*/}, data){
            let db = firebase.database();
            return db.ref("/localizations/keys/" + data.key_id)
            .set(null).then(() => {
                LocalizationStoreUtils.removeLocaleKeys([data.key_name])// optional
                return LocalizationStoreUtils.fethLocalizations()
            }, (reason) => {
                console.error("addGroup failed: " + reason);
            });
        },
        addGroup({/*commit*/}, data){
            let db = firebase.database();
            return db.ref("/localizations/groups/" + uuid.v4().replace(/-/g, ""))
            .set({name:data.name, color:data.color, order:data.order, owner:firebase.auth().currentUser.uid, date:TimeUtils.now()}).then(() => {
                return LocalizationStoreUtils.fethLocalizations()
            }, (reason) => {
                console.error("addGroup failed: " + reason);
            });
        },
        updateGroup({/*commit*/}, data){
            let db = firebase.database();
            return db.ref("/localizations/groups/" + data.id)
                .set({name:data.name, color:data.color, order:data.order, owner:firebase.auth().currentUser.uid, date:TimeUtils.now()}).then(() => {
                    return LocalizationStoreUtils.fethLocalizations()
                }, (reason) => {
                    console.error("addGroup failed: " + reason);
                });
        },
        deleteGroup({/*commit*/}, id){
            let localization = LocalizationStoreUtils.getLocalizations()
            let db = firebase.database();
            let data = {}
            data["groups/" + id] = null
            var removedKeys = []
            for (let l in localization.keys){
                let item = localization.keys[l]
                if (item.group_id == id){
                    removedKeys.push(item.key_name)
                    data["keys/" + item.key_id] = null
                }
            }
            LocalizationStoreUtils.removeLocaleKeys(removedKeys)// optional
            return db.ref("/localizations/")
            .update(data).then(() => {
                return LocalizationStoreUtils.fethLocalizations()
            }, (reason) => {
                console.error("addGroup failed: " + reason);
            });
        },
        fethLocalizations({commit}) {
            //let user = firebase.auth().currentUser;
            let db = firebase.database();
            //console.info("localizations: " + user.uid);
            return db.ref("/localizations")
                .once("value")
                .then((snapshot) => {
                    if (snapshot.val()){
                        commit("setLocalizations", deserialize(LocalizationModel, snapshot.val()));
                    }
                }).catch((error) => {
                    throw error
                })
        },
        getLocaleKeys({commit}){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "GET",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'getLocaleKeys', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }else{
                                    // succes
                                    return data.text()
                                        .then((data)=>{
                                            console.log(data)
                                            return JSON.parse(data)
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        removeLocaleKeys({/*commit*/}, data){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body: JSON.stringify(keys) // array of keys
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'removeLocaleKeys', requestOptions)
                            .then(async data => {
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
        uploadLocales({/*commit*/}, data){
            return Promise.all([
                firebase.auth().currentUser.getIdToken()
                    .then((token) => {
                        let requestOptions = {
                            method: "POST",
                            headers: { "Content-Type": "application/json", 'Authorization': token},
                            body: data // array of keys
                        };
                        return fetch(process.env.VUE_APP_FB_BACKEND_URL + 'uploadLocales', requestOptions)
                            .then(async data => {
                                console.log("uploadLocales data.status: ", data.status)
                                if (data.status != 200) {
                                    return data.text()
                                        .then((data)=>{
                                            throw data
                                        })
                                        .catch((error) => {
                                            throw error
                                        })
                                }
                            })
                            .catch((error) => {
                                throw error
                            })
                    })
            ])
        },
    }
}
